module.exports = __webpack_public_path__ + "static/media/a5.3ae38faf.png";